import defaultState from './summaryDefaultState';
import {
  SUMMARY_ADD_UNAVAILABLE_PRODUCTS_TO_LIST,
  SUMMARY_SET_MODAL_TYPE,
  SUMMARY_SET_CURRENT_CONFIGURATION,
  SUMMARY_SET_MODAL_STATE,
  SUMMARY_SET_SHOPPING_ITEMS,
  SUMMARY_SET_STATE,
  SUMMARY_SET_STORE_AVAILABILITIES,
  SUMMARY_SET_STORE_ID,
  SUMMARY_SET_VPC_CODE,
  SUMMARY_SET_DESIGN_LINK,
  SUMMARY_SET_CONFIRMATION_CARD_TYPE,
  SUMMARY_CLEAR_BUTTON,
  SUMMARY_SET_COPY_DESIGN_CODE_STATE,
  SUMMARY_SET_COPY_DESIGN_LINK_STATE,
  SUMMARY_SET_FAILED_SHOPPING_ITEMS,
  SUMMARY_SET_SHARE_DESIGN_CARD,
  SUMMARY_SET_HOME_DELIVERY,
  SUMMARY_SET_FINANCING_OPTIONS,
  SUMMARY_SET_SCENE_IMAGE,
} from '../actionConstants';
import { Summary } from './summaryTypes';

export default (state: Summary = defaultState, action: any) => {
  switch (action.type) {
    case SUMMARY_SET_STORE_AVAILABILITIES:
      return {
        ...state,
        storeAvailabilities: action.payload.specificStoreAvailabilities,
      };

    case SUMMARY_SET_STORE_ID: {
      return {
        ...state,
        storeId: action.payload.storeId,
      };
    }

    case SUMMARY_SET_SHOPPING_ITEMS:
      return {
        ...state,
        shoppingItems: action.payload.shoppingItems,
      };

    case SUMMARY_SET_VPC_CODE:
      return {
        ...state,
        vpcCode: action.payload.vpcCode,
      };

    case SUMMARY_SET_DESIGN_LINK:
      return {
        ...state,
        designLink: action.payload.designLink,
      };

    case SUMMARY_SET_SCENE_IMAGE:
      return {
        ...state,
        sceneImage: action.payload.sceneImage,
      };

    case SUMMARY_SET_FAILED_SHOPPING_ITEMS:
      return {
        ...state,
        failedShoppingItems: action.payload.failedShoppingItems,
      };

    case SUMMARY_SET_STATE:
      return {
        ...state,
        states: {
          ...state.states,
          [action.payload.target]: action.payload.state,
        },
      };

    case SUMMARY_SET_MODAL_STATE:
      return {
        ...state,
        modal: {
          ...state.modal,
          showModal: action.payload.modalState,
        },
      };

    case SUMMARY_SET_MODAL_TYPE:
      return {
        ...state,
        modal: {
          ...state.modal,
          modalType: action.payload.modalType,
        },
      };

    case SUMMARY_ADD_UNAVAILABLE_PRODUCTS_TO_LIST:
      return {
        ...state,
        addUnavailableProductsToList:
          action.payload.addUnavailableProductsToList,
      };

    case SUMMARY_SET_CONFIRMATION_CARD_TYPE:
      return {
        ...state,
        confirmationCardType: action.payload.confirmationCardType,
      };

    case SUMMARY_CLEAR_BUTTON:
      return {
        ...state,
        states: {
          ...state.states,
          addToList: defaultState.states.addToList,
          addToCart: defaultState.states.addToCart,
        },
      };

    case SUMMARY_SET_CURRENT_CONFIGURATION:
      return {
        ...state,
        currentConfiguration: action.payload.currentConfiguration,
      };

    case SUMMARY_SET_COPY_DESIGN_CODE_STATE:
      return {
        ...state,
        shareDesignCard: {
          ...state.shareDesignCard,
          copyDesignCodeState: action.payload.saveDesignCardCopyState,
        },
      };

    case SUMMARY_SET_COPY_DESIGN_LINK_STATE:
      return {
        ...state,
        shareDesignCard: {
          ...state.shareDesignCard,
          copyDesignLinkState: action.payload.saveDesignCardLinkState,
        },
      };
    case SUMMARY_SET_SHARE_DESIGN_CARD:
      return {
        ...state,
        shareDesignCard: {
          ...state.shareDesignCard,
          [action.payload.target]: action.payload.state,
        },
      };

    case SUMMARY_SET_HOME_DELIVERY:
      return {
        ...state,
        homeDelivery: {
          ...state.homeDelivery,
          [action.payload.target]: action.payload.state,
        },
      };

    case SUMMARY_SET_FINANCING_OPTIONS:
      return {
        ...state,
        financingOptions: action.payload.financingOptions,
      };

    default:
      return state;
  }
};
